// Currency utility for AED formatting
export const Currency = {
  // AED symbol using the custom font
  symbol: '&#xE000;',
  
  // Format amount with AED symbol
  format: (amount, decimals = 2) => {
    const formattedAmount = typeof amount === 'number' 
      ? amount.toFixed(decimals)
      : parseFloat(amount || 0).toFixed(decimals);
    
    return (
      <span>
        <span className="aed-symbol">
          &#xE000;
        </span>
        {formattedAmount}
      </span>
    );
  },
  
  // Format amount as text (for non-React contexts)
  formatText: (amount, decimals = 2) => {
    const formattedAmount = typeof amount === 'number' 
      ? amount.toFixed(decimals)
      : parseFloat(amount || 0).toFixed(decimals);
    
    return `AED ${formattedAmount}`;
  }
};